<template>
  <div class="opc-payment-apple-pay">
    <zm-alert v-if="paymentError" type="error" show-icon :closable="false" class="opc-payment-apple-pay__error">
      <div v-html="paymentError" />
    </zm-alert>
    <p v-if="paymentMessage" class="opc-payment-apple-pay__desc">{{ paymentMessage }}</p>
    <slot name="payment-method-error"></slot>
    <div class="opc-payment-apple-pay__action">
      <div class="opc-payment-apple-pay__action__checkout authorize-btn" ref="adyen-container"></div>
    </div>
    <zm-dialog width="500px" :visible="isUpdatingAccount" class="opc-payment-apple-pay__waiting-dialog" append-to-body>
      <h2 class="opc-payment-apple-pay__waiting-dialog__title">
        {{ __$t('billing.payment.waiting_updating_pay_method_title') }}
      </h2>
      <p class="opc-payment-apple-pay__waiting-dialog__desc">
        {{ __$t('billing.payment.waiting_updating_pay_method_desc') }}
      </p>
    </zm-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { payMethodMap, paymentGatewayMap } from '../../common/constant'
import PaymentBase from './common/PaymentBase'
import adyenMixin, { adyenPaymentMethodName } from './mixins/adyen-mixin'
import { logger } from '../../utils/log'
import { APP_NAMESPACE } from '../../store'
import { translateMixins } from '../../plugins/i18n'

export default {
  name: 'ApplePay',
  extends: PaymentBase,
  mixins: [adyenMixin, translateMixins],
  data() {
    return {
      paymentError: null,
      isUpdatingAccount: false
    }
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, ['selectedPaymentMethod', 'getHpmPassthroughValForBackupPayment'])
  },
  inject: ['isCheckout'],
  methods: {
    initApplePay() {
      if (!this.isAdyenApplePayEnabled) {
        logger.error('Payment not available: Apple Pay')
        return
      }
      this.initAdyenPayment(adyenPaymentMethodName.APPLE_PAY, {
        adyenContainer: this.$refs['adyen-container'],
        paymentSupportedMsg: this.__$t('billing.payment.apple_pay_desc'),
        paymentUnsupportedMsg: this.__$t('billing.payment.apple_pay_not_supported'),
        buttonType: this.isCheckout ? 'check-out' : 'plain', // https://developer.apple.com/design/human-interface-guidelines/apple-pay/overview/buttons-and-marks
        buttonColor: 'black',
        onAuthorizedCallback: async (resolve, reject, event) => {
          this.paymentError = null
          const applePayPaymentData = event && event.payment && event.payment.token && event.payment.token.paymentData
          if (applePayPaymentData) {
            const paymentResponse = {
              integrationType: adyenPaymentMethodName.APPLE_PAY,
              refId: JSON.stringify(applePayPaymentData),
              success: !!applePayPaymentData
            }
            if (!this.isPrimary) {
              paymentResponse.field_passthrough7 = this.getHpmPassthroughValForBackupPayment(this.action)
            }
            const paymentInfo = {
              paymentType: payMethodMap.apple,
              paymentGateway: paymentGatewayMap.Adyen,
              paymentResponse: JSON.stringify(paymentResponse)
            }
            this.$emit('submit-success', paymentInfo)
            resolve()
          } else {
            this.paymentError = this.__$t('billing.unknown_error_try_again')
            this.$emit('submit-error', this.paymentError)
            reject()
          }
        }
      })
      this.watchButtonIsReady()
    },
    $submit(paymentInfo) {
      return this.updatePayMethod(paymentInfo)
    },
    toggleUpdatingAccount(isUpdatingAccount) {
      this.isUpdatingAccount = isUpdatingAccount
    }
  },
  mounted() {
    this.ready()
  },
  watch: {
    selectedPaymentMethod: {
      immediate: true,
      handler(newVal) {
        if (newVal === payMethodMap.apple) {
          this.rootReady.ready(this.initApplePay.bind(this))
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-payment-apple-pay {
  padding-top: 16px;

  &__waiting-dialog {
    color: #232333;
    margin-top: 10%;

    &__title {
      font-weight: 700;
      font-size: 22px;
      margin-bottom: 16px;
    }

    &__desc {
      font-weight: 500;
      font-size: 14px;
    }
  }

  &__error {
    margin-bottom: 16px;
    color: #80384d;
    background-color: #f3c2d0;
  }

  &__desc {
    font-weight: 500;
    font-size: 14px;
    color: #00053d;
  }

  &__action {
    display: flex;
    margin-top: 16px;

    @include media(mobile, tablet) {
      display: flex;
      flex-direction: column;
    }

    &__checkout {
      button {
        margin-right: 16px;
      }
      button:disabled {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }
}
</style>
